export default {
    application: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    campaignEndDate: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    displayName: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    customProperties: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    featureFlags: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
    url: {
        Production: false,
        PreProduction: false,
        UAT: false,
        SVT: false,
        QA: true,
        Mock: true,
        Development: true,
        Local: true
    },
};
